import is from 'is_js';

import "toastr/build/toastr.min.css";
import toastr from 'toastr';

toastr.options = {
    "preventDuplicates": true,
    "hideDuration": 400
};

/**
 * Funkcje pomocniczne
 */

export const getSiblings = element => {
    let siblings = [];
    let node = element.parentNode.firstChild;

    do {
        if (node.nodeType === 1) {
            siblings.push(node);
        }
    } while (node = node.nextElementSibling);

    return siblings;
};

export const getSibling = (element, sibling) => {
    const el = isElement(element) ? element : document.querySelector(element);
    if (el === null) return false;

    const node = el.parentNode.querySelector(sibling);

    return (node && node.nodeType === 1) ? node : false;
};

/**
 * Szuka najbliższego rodzica w strukturze DOM
 * @param element
 * @param className
 * @returns {*}
 */
export const getParent = (element, className) => {
    while ( !element.classList.contains(className) && (element = element.parentElement) );
    return element;
};

/**
 * Znajduje bezpośrednie dzieci od wskazanego node
 * @param parent
 * @param selector
 * @returns {T[]}
 */
export const getChildren = (parent, selector) => {
    return Array.prototype.filter.call(parent.children, (node) => {
        return node.matches(selector);
    });
};

export const createMessageBox = (status, text) => {
    let elementPattern = '<div class="msg {{class}} text-left"><div class="msg__content">{{text}}</div></div>';
    const elementClass = status ? 'msg--success' : 'msg--error';

    elementPattern = elementPattern.replace('{{class}}', elementClass);
    elementPattern = elementPattern.replace('{{text}}', text);

    return elementPattern;
};

export const createPopover = text => {
    let elementPattern = '<div class="popover popover--red">{{text}}</div>';

    elementPattern = elementPattern.replace('{{text}}', text);

    return elementPattern;
};

export const isElement = o => {
    return (
        typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
    );
};

export const isNode = o => {
    return (
        typeof Node === "object" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
    );
};

export const addLoader = (where, opts = {}) => {
    const container = isElement(where) ? where : document.querySelector(where);
    if (container === null) return false;

    const defaults = {
        fullscreen: false,
        text: null
    };
    Object.assign(defaults, opts);

    const template = `<div class="loader${defaults.fullscreen ? ' loader--full-screen' : ''}">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
        
        ${defaults.text ? '<div class="loader__text">' + defaults.text + '</div>' : ''}
    </div>`;

    container.insertAdjacentHTML('afterbegin', template);
};

export const removeLoader = where => {
    const loader = getSibling(where, '.loader') || where.querySelector('.loader');
    if (loader) loader.parentNode.removeChild(loader);
};

export const addAlert = (where, type, message, onlyOne = false, placement = 'afterend') => {
    const template = `
        <div class="msg msg--${type} text-left"><div class="msg__content">${message}</div></div>
    `;
    const container = isElement(where) ? where : document.querySelector(where);

    if (onlyOne) {
        switch (placement) {
            case 'beforebegin':
                // TODO
                break;
            case 'afterbegin':
                if (getChildren(container, '.msg').length) return false;
                break;
            case 'beforeend':
                if (getChildren(container, '.msg').length) return false;
                break;
            case 'afterend':
                // TODO
                break;
        }
    }
    container.insertAdjacentHTML(placement, template);
};

export const getTranslation = translation => {
    return window.translations[translation] || '';
};

export const showMessage = (status, text, title = '', params = {}) => {
    if (text.length > 0) {
        params = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": true,
            "progressBar": false,
            "positionClass": "toast-top-right",
            "preventDuplicates": true,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "2000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut",
            ...params
        };
        toastr[status](text, title, params);
    }
};

export const getDocumentHeight = () => {
    const body = document.body, html = document.documentElement;

    return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
};

/**
 * Pobiera wysokość okna przeglądarki
 * @returns {number}
 */
export const getWindowHeight = () => {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
};

/**
 * Pobier szerokość okna przeglądarki
 * @returns {number}
 */
export const getWindowWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
};

/**
 * Pobiera wartość scrolla okna przeglądarki
 * @returns {number}
 */
export const getScroll = () => {
    return {
        x: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    };
};

export const getStyleValue = (element, property) => {
    const elementComputedStyles = window.getComputedStyle(element);
    return element.style[property] || elementComputedStyles[property];
};

export const smoothScroll = (element, compensateForHeader = false) => {
    const el = isElement(element) ? element : document.querySelector(element);
    if (el) {
        const bbox = el.getBoundingClientRect();
        let top = bbox.top + (window.pageYOffset || document.documentElement.scrollTop);

        if (compensateForHeader) {
            const header = document.querySelector('.header');
            if (header) {
                top = top + ( (header.offsetHeight + 15) * -1 );
            }
        }

        window.scrollTo({
            top: top,
            behavior: "smooth",
        });
    }
};

export const preparePrice = p => {
    let price = p;
    if (typeof p === "string") {
        price = p.replace(',', '.');
    }

    return parseFloat(parseFloat(price).toFixed(2)) || 0;
};

export const debounce = (fn, delay = 500) => {
    let timer, args;

    function debounced() {
        args = Array.prototype.slice.call(arguments);

        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
            fn.apply(null, args);
        }, delay);
    }

    return debounced;
};

export const debounced = debounce(cb => {
    if (typeof cb === "function") cb();
}, 500);

export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};

export const getCookie = name => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
};

export const eraseCookie = name => {
    document.cookie = name + '=; Max-Age=-99999999;';
};

export const confirmDialog = (e, cb) => {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(e.currentTarget) || $(e.target);
    $this.fancyConfirm({
        title: $this.attr('data-title') || "Czy jesteś pewien?",
        message: $this.attr('data-message') || "Pamiętaj, że proces usuwania jest nieodwracalny",
        okButton: $this.attr('data-ok') || 'Tak, usuń',
        noButton: $this.attr('data-no') || 'Anuluj',
        okIcon: $this.attr('data-ok-icon') || 'trash',
        closeButton: $this.attr('data-close-button') || false,
        callback: function (value) {
            if (typeof cb === "function") {
                cb(value);
            }
        }
    });
};

export const createElementFromHTML = html => {
    const div = document.createElement('div');
    div.innerHTML = html.trim();

    return div.firstChild;
};

export const makeQueryStringData = data => {
    if (typeof data !== "object") return false;

    return Object.keys(data).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
};

let lastScrollTop = 0;
export const getScrollDirection = () => {
    const st = getScroll().y;
    let scrollDirection = '';
    if (st > lastScrollTop){
        scrollDirection = 'scrolldown';
    } else {
        scrollDirection = 'scrollup';
    }
    lastScrollTop = st <= 0 ? 0 : st;
    return scrollDirection;
};

window.showMessage = showMessage;

// Import assetów ze starych widoków kodowanych w 2017

const Utils = {
    isTouch () {
        return is.mobile() || is.tablet();
    },
    jsLink() {
        $(document).on('click', '[data-js-url]', (e) => {
            e.stopPropagation();
            e.preventDefault();
            let $_ = $(e.target);
            let url = $_.attr('data-js-url');
            if (url) window.location.href = url;
        })
    },
    addEvent(eventName, eventArgs = null) {
        $(document.body).trigger(eventName, eventArgs);
    },
    bindEvent(eventName, listener) {
        $(document.body).on(eventName, listener);
    },
    jsTabs() {
        const _self = this;
        let $tabs = $('.js-tabs');
        let $tabsNav = $('.js-tabs__nav');
        let $tabsContent = $('.js-tabs__content');
        if (!$tabs.length) return false;
        $tabs.on('click', '.js-tabs__item-nav', (e) => {
            let $_ = $(e.target);
            if ($_.hasClass('active')) return false;
            let target = $_.attr('data-nav');

            $_.closest($tabs).find($tabsNav).find('.active').removeClass('active');
            $_.addClass('active');

            $_.closest($tabs).find($tabsContent).find('[data-content]').stop().slideUp();
            $_.closest($tabs).find($tabsContent).find('[data-content="' + target + '"]').stop().slideDown();

            _self.addEvent('tabChange', $_.closest($tabs).find($tabsContent).find('[data-content="' + target + '"]'));

        });
    },
    jsAccordion() {
        const _self = this;
        let $accordion = $('.js-accordion');
        let $accordionTrigger = $('.js-accordion__trigger');
        let $accordionContent = $('.js-accordion__content');
        if (!$accordion.length) return false;
        $accordion.on('click', '.js-accordion__trigger', (e) => {
            let $_ = $(e.target);
            let content = $_.siblings('.js-accordion__content');
            let contentText = $_.closest('.js-accordion__single').find('[data-content]');
            let $accordionInst = $_.closest($accordion);
            if ($_.hasClass('active')) {
                $_.removeClass('active');
                content.stop(true, true).slideUp();
                if (contentText.length) {
                    contentText.html($accordionInst.attr('data-open'));
                }
            } else {
                // close others
                content.closest($accordion).find($accordionContent).not(content).stop(true, true).slideUp();
                content.closest($accordion).find($accordionTrigger).not($_).removeClass('active');
                if (contentText.length) {
                    content.closest($accordion).find('[data-content]').not(contentText).attr('data-open');
                }

                // open current
                $_.addClass('active');
                content.stop(true, true).slideDown();

                if (contentText.length) {
                    contentText.html($accordionInst.attr('data-close'));
                }
            }
        });
    },
    imageScaleEffect() {
        const _self = this;
        if (!$('[data-scale]').length || _self.isTouch()) return false;

        $("[data-scale]").on('mouseenter mousemove mouseleave', (e) => {
            let $_ = $(e.delegateTarget);
            let $_Image = $_.find('[data-scale-image]');

            const onmouseenter = () => {
                $_Image.css({
                    'transform': `scale(${$_.attr('data-scale')})`
                });
            }

            const onmousemove = () => {
                $_Image.css({
                    'transform-origin': ((e.pageX - $_.offset().left) / $_.outerWidth()) * 100 + '% ' + ((e.pageY - $_.offset().top) / $_.outerHeight()) * 100 +'%'
                });
            }

            const onmouseleave = () => {
                $_Image.css({
                    'transform': `scale(1)`
                });
            }

            switch (e.type) {
                case "mouseenter":
                    onmouseenter();
                    break;
                case "mousemove":
                    onmousemove();
                    break;
                case "mouseleave":
                    onmouseleave();
                    break;
            }
        });
    },
    getLazyImage(url) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => {
                resolve(url)
            }
            img.onerror = () => {
                reject(url);
            }
            img.src = url;
        });
    },
    addLoader(element, removeOthers = false) {
        const _self = this;
        $(document).find('.latest-added').removeClass('latest-added');
        $(element).append('<div class="loader latest-added"></div>');
        let loader = $(element).find('.loader');
        if (removeOthers) {
            let otherLoaders = $('body').find('.loader').not('.latest-added');
            _self.removeLoader(otherLoaders, false);
        }
        return loader;
    },
    removeLoader(loader, timeout = true) {
        loader.fadeOut(250);
        if (timeout) {
            setTimeout(()=>{
                loader.remove();
            }, 300);
        } else {
            loader.remove();
        }
    },
    jsChangeImage() {
        const _self = this;
        let $imageWrap = $('[data-change-image]');
        let $imageBG = $('[data-change-image-bg]');
        let $imageEl = $('.js-change-image__el');
        if (!$imageWrap.length || _self.isTouch()) return false;
        $imageWrap.on('mouseenter mouseleave', '.js-change-image__el', (e) => {
            let $_ = $(e.target);

            const onmouseenter = () => {
                if ($_.hasClass('active')) return false;

                $imageEl.not($_).removeClass('active');
                $_.addClass('active');

                let loader = false;

                if (!$_.hasClass('has-image-loaded')) {
                    loader = _self.addLoader($imageWrap, true);
                }

                _self.getLazyImage($_.attr('data-bg')).then((data)=>{
                    $_.addClass('has-image-loaded');
                    $imageBG.css({
                        'background-image': `url("${data}")`
                    });
                    if (loader != false) {
                        setTimeout(()=>{
                            _self.removeLoader(loader);
                        }, 500)
                    }
                }).catch((data)=>{
                    console.log(data, ' image not loaded');
                    if (loader != false) {
                        _self.removeLoader(loader);
                    }
                });

            }

            const onmouseleave = () => {
            }

            e.type === 'mouseenter' ? onmouseenter() : onmouseleave();

        });
    },
    scrollTop() {
        $('.scroll-top').on('click', () => {
            $('body, html').animate({
                scrollTop: 0
            }, 600);
        })
    },
    scrollDown() {
        $('.scroll-down').on('click', () => {
            if ($('.app').find('section').eq(1).length) {
                let scTop = $('.app').find('section').eq(1).offset().top;
                $('body, html').animate({
                    scrollTop: scTop + 10
                }, 600);
            }
        })
    },
    jsTicker() {
        if (!$('.js-ticker').length) return false;
        const $ticker = $('.js-ticker');
        const $tickerHeight = $('.js-ticker').height();
        let jsTickerItem = '.js-ticker__item';
        let countItems = $(jsTickerItem).length;
        let position = 0;

        let isPaused = false;

        let tickerTimer = setInterval(()=>{
            if (!isPaused) {
                if (countItems - 1 == position) position = 0;
                $ticker.stop(true,true).animate({
                    top: (position * $tickerHeight) * -1 + "px"
                }, 400);
                position += 1;
            }
        }, 2000);

        $ticker.hover(function() {
                isPaused = true;
            },function() {
                isPaused = false;
            }
        );
    },
    getScrollbarWidth() {
        const scrollDiv = document.createElement("div");
        scrollDiv.className = "scrollbar-measure";
        document.body.appendChild(scrollDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        document.body.removeChild(scrollDiv);

        return scrollbarWidth;
    },
    compensateForScrollbar(action = "init") {
        const _self = this;
        switch (action) {
            case "init":
                const scrollbarWidth = _self.getScrollbarWidth();
                $("head").append('<style type="text/css"></style>');
                const element = $("head").children(':last');
                element.html(`.compensate-for-scrollbar-padding { padding-right: ${scrollbarWidth}px; } .compensate-for-scrollbar-position { right: ${scrollbarWidth}px; }`);
                break;
            case "add":
                break;
            case "remove":
                break;
        }
    },
    init (){
        this.jsLink();
        this.jsTabs();
        this.jsAccordion();
        this.jsChangeImage();
        this.imageScaleEffect();
        this.scrollTop();
        this.scrollDown();
        this.jsTicker();
        this.compensateForScrollbar();
    }
};

export { Utils as default }



// WEBPACK FOOTER //
// ./src/assets/js/common/Utils.js